import * as t from 'io-ts';
import { createLocalStorageItem } from 'src/domains/layouts/state/localStorage/createLocalStorageItem';
import { LocalStorageItemState } from 'src/domains/layouts/state/localStorage/LocalStorageItemState';
import { buildValidator } from 'src_common/common/mobx-utils/buildValidator';

const decodeIO = t.boolean;

const decode = buildValidator('localStorageCookiesPolicy.decodeIO', decodeIO, true);

export const localStorageCookiesPolicy = (withAutorun: boolean, key: string): LocalStorageItemState<boolean> => {
    return createLocalStorageItem(withAutorun, {
        key: key,
        decode: decode,
        defaultValue: false
    });
};
